export default __webpack_public_path__ + "pdf/privacy_policy.90728320.pdf";